export default "__VITE_ASSET__94595698__"